import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

export const WhyUsD2D = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="d2d-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-block px-4 py-2 bg-white/10 rounded-full text-sm font-medium text-[#00bcd4] mb-6">
            Our Approach
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-6">
            D2D Model — Your End-to-End Partner
          </h2>
          <p className="text-slate-400 leading-relaxed mb-8">
            Our Documentation to Disbursement model ensures you have expert support 
            at every step of your financial journey. We don't just file paperwork — 
            we actively manage and follow up until successful completion.
          </p>
          <div className="space-y-4">
            {[
              'Initial assessment and eligibility evaluation',
              'Complete documentation preparation and verification',
              'Application submission to relevant authorities',
              'Active follow-up and status tracking',
              'Liaison with banks and government departments',
              'Support until final disbursement'
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <CheckCircle2 className="w-5 h-5 text-[#00bcd4] flex-shrink-0" />
                <span className="text-slate-300 text-sm">{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 gap-4"
        >
          {[
            { number: '01', label: 'Documentation' },
            { number: '02', label: 'Verification' },
            { number: '03', label: 'Processing' },
            { number: '04', label: 'Disbursement' }
          ].map((step, index) => (
            <div
              key={step.number}
              className={`p-8 rounded-2xl ${
                index % 2 === 0 ? 'bg-white/5' : 'bg-gradient-to-br from-[#3b5998]/20 to-[#00bcd4]/20'
              }`}
            >
              <span className="text-5xl font-bold text-white/20 font-mono block mb-2">
                {step.number}
              </span>
              <span className="text-white font-medium">{step.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
